import { hasText } from 'shared/lib/common-util'
import { PreviousDocument } from '../common/types'
import { RuleResult } from '../../../types/DeclarationP5'

const NA62Validator = {
  validatePreviousDocumentReferenceNumberRequirement: (previousDocument?: PreviousDocument): RuleResult => {
    if (!previousDocument) return 'OPTIONAL'

    if (!hasText(previousDocument.documentType) && !hasText(previousDocument.procedureType)) {
      return 'NOT_ALLOWED'
    }
    if (previousDocument.procedureType === 'PIIR') {
      return 'NOT_ALLOWED'
    }

    return 'OPTIONAL'
  },
} as const

export default NA62Validator
